import type { CreditoDoItemApi } from '@/services/CreditoIbsCbs';

const ROTULOS: Record<string, string> = {
  'com-credito': 'Com crédito',
  'sem-credito': 'Sem crédito',
  'credito-presumido': 'Presumido',
  ajuste: 'Ajuste',
  estorno: 'Estorno',
  pendente: 'Pendente',
};

export function rotuloTratamento(ibs: string, cbs: string): string {
  const rotuloIbs = ROTULOS[ibs] ?? ibs;
  const rotuloCbs = ROTULOS[cbs] ?? cbs;
  return rotuloIbs === rotuloCbs ? rotuloIbs : `IBS: ${rotuloIbs} · CBS: ${rotuloCbs}`;
}

const centavos = (valor: number) => Math.round(valor * 100);

export interface TotaisDoCredito {
  destacadoIbs: number;
  aApropriarIbs: number;
  disponivelIbs: number;
  destacadoCbs: number;
  aApropriarCbs: number;
  disponivelCbs: number;
  estornoIbs: number;
  estornoCbs: number;
}

/** Soma em centavos inteiros e devolve em reais: 0,10 + 0,20 tem de dar 0,30. */
export function totaisDoCredito(itens: CreditoDoItemApi[]): TotaisDoCredito {
  const soma = (campo: keyof CreditoDoItemApi) =>
    itens.reduce((acc, item) => acc + centavos(Number(item[campo]) || 0), 0) / 100;
  return {
    destacadoIbs: soma('DestacadoIbs'),
    aApropriarIbs: soma('AApropriarIbs'),
    disponivelIbs: soma('DisponivelIbs'),
    destacadoCbs: soma('DestacadoCbs'),
    aApropriarCbs: soma('AApropriarCbs'),
    disponivelCbs: soma('DisponivelCbs'),
    estornoIbs: soma('EstornoIbs'),
    estornoCbs: soma('EstornoCbs'),
  };
}
